import { AxiosResponse } from 'axios'
import { miscApiClient } from '../httpClient'

export async function postMockRequest(data: any): Promise<any> {
    return await miscApiClient.post(`/api/v1/mock/data`, data)
}

export async function getUseCases(): Promise<any> {
    return await miscApiClient.get(`/api/v1/mock/usecase`)
}

export const getNodeETHAddress = async () => {
    return await miscApiClient.get('/api/v1/chain/address/wallet')
}

export const getPaymentCollectorContractETHAddress = async () => {
    return await miscApiClient.get('/api/v1/chain/address/rhiza-payment-collector')
}

export const getTokenPool = async () => {
    return await miscApiClient.get('/api/v1/chain/token-pool')
}

export const getIdentity = async () => {
    return await miscApiClient.get('/api/v1/identity')
}

export const getConfig = async () => {
    return await miscApiClient.get<any, AxiosResponse<any>>('/api/v1/config')
}

export const setConfig = async (payload: any) => {
    return await miscApiClient.post('/api/v1/config', payload)
}

export const EdiToJson = async (payload: any) => {
    return await miscApiClient.post('/api/v1/edi-json', payload)
}

export const JsonToEdi = async (payload: any) => {
    return await miscApiClient.post('/api/v1/json-edi', payload)
}
